import React, { memo } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { COACHING } from '../../constants';
import { CoachingTabs } from '../../utils/typeConstants';
import warning from '../../assets/warning.png';

interface RecordingEndedModalProps {
    visible: boolean;
    onClose: () => void;
}

export const RecordingEndedModal = memo(({ visible, onClose }: RecordingEndedModalProps) => {
    const navigate = useNavigate();

    const handleContinue = () => {
        onClose();
        navigate(`${COACHING}/${CoachingTabs.RecordingHistory}`);
    };

    return (
        <Dialog
            visible={visible}
            onHide={onClose}
            modal
            showHeader={false}
            closable={false}
            style={{ width: '500px', borderRadius: '16px', overflow: 'hidden' }}
            contentStyle={{ textAlign: 'center', padding: '0', borderRadius: '16px' }}
        >
            <div style={{ padding: '30px 20px 20px' }}>
                {/* Icon — matches PersistentIframeModal exactly */}
                <div
                    style={{
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        margin: '0 auto 16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 32,
                        background: 'linear-gradient(90deg, #EE69DF 0%, #7D71E2 100%)',
                        fontWeight: 'bold',
                        color: '#fff',
                    }}
                >
                    <img src={warning} alt="Warning" />
                </div>

                {/* Title */}
                <h3
                    style={{
                        font: 'Urbanist',
                        marginBottom: 12,
                        color: '#7D71E2',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        margin: '0 0 12px 0',
                    }}
                >
                    Recording Ended
                </h3>

                {/* Body */}
                <p style={{ fontSize: 16, color: '#404D61', marginBottom: 12, fontWeight: 'bold' }}>
                    Do you want to navigate to the recording library?
                </p>
                <p
                    style={{
                        font: 'Urbanist',
                        fontWeight: 500,
                        lineHeight: '100%',
                        color: '#404D61',
                        marginBottom: 24,
                    }}
                >
                    Note: This recording may take some time to process
                </p>
                <p
                    style={{
                        fontSize: 14,
                        fontStyle: 'italic',
                        color: '#C90370',
                        marginBottom: 24,
                        fontWeight: 700,
                        lineHeight: '1.4',
                    }}
                >
                    Note: This recording will only be available for 14 days from the date of creation
                </p>

                {/* Buttons */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
                    <Button
                        label="Close"
                        className="p-button-outlined p-button-rounded"
                        style={{
                            color: '#D81B60',
                            borderColor: '#D81B60',
                            fontWeight: 600,
                            padding: '10px 24px',
                        }}
                        onClick={onClose}
                    />
                    <Button
                        label="Continue"
                        className="p-button-rounded"
                        style={{
                            background: 'linear-gradient(90deg, #F069DE 0%, #6B6FF3 100%)',
                            border: 'none',
                            fontWeight: 600,
                            padding: '10px 24px',
                        }}
                        onClick={handleContinue}
                    />
                </div>
            </div>
        </Dialog>
    );
});

RecordingEndedModal.displayName = 'RecordingEndedModal';
